<template>
  <v-container fluid>
    <v-row align="center" class="mb-2">
      <v-col cols="auto">
        <h2>Environment Profile</h2>
        <div class="text-caption text--secondary">
          Settings here are returned to clients that fetch their environment
          profile from this backend.
        </div>
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="loading || saving"
          @click="save"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
      </v-col>
    </v-row>

    <v-card :loading="loading">
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            v-model="form.description"
            label="Description"
            outlined
            dense
          />

          <v-row>
            <v-col cols="12" md="6">
              <v-textarea
                v-model="form.clientEnv"
                label="Client (~/.config/cordatus/.env)"
                rows="14"
                outlined
                dense
                hide-details
                class="env-textarea"
                placeholder="KEY=VALUE per line"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea
                v-model="form.streamEngineEnv"
                label="Stream Engine (~/.cordatus/cordatus_se/.env)"
                rows="14"
                outlined
                dense
                hide-details
                class="env-textarea"
                placeholder="KEY=VALUE per line"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea
                v-model="form.inferenceEngineEnv"
                label="Inference Engine (~/.cordatus/engine/.env)"
                rows="14"
                outlined
                dense
                hide-details
                class="env-textarea"
                placeholder="KEY=VALUE per line"
              />
            </v-col>
          </v-row>

          <v-alert v-if="errorMessage" type="error" dense outlined class="mt-3">
            {{ errorMessage }}
          </v-alert>
          <v-alert
            v-if="successMessage"
            type="success"
            dense
            outlined
            class="mt-3"
          >
            {{ successMessage }}
          </v-alert>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { apiService } from '../service/api.service'

const emptyForm = () => ({
  description: '',
  clientEnv: '',
  streamEngineEnv: '',
  inferenceEngineEnv: ''
})

export default Vue.extend({
  name: 'EnvProfile',
  data: () => ({
    loading: false,
    saving: false,
    errorMessage: '',
    successMessage: '',
    form: emptyForm()
  }),
  mounted () {
    this.fetchProfile()
  },
  methods: {
    async fetchProfile () {
      this.loading = true
      this.errorMessage = ''
      try {
        const res = await apiService.get('/admin-env-profile')
        const p = (res.data && res.data.data) || {}
        this.form = {
          description: p.description || '',
          clientEnv: p.client_env || '',
          streamEngineEnv: p.stream_engine_env || '',
          inferenceEngineEnv: p.inference_engine_env || ''
        }
      } catch (e) {
        this.errorMessage =
          (e.response && e.response.data && e.response.data.error) ||
          'Failed to load environment profile'
      } finally {
        this.loading = false
      }
    },
    async save () {
      this.saving = true
      this.errorMessage = ''
      this.successMessage = ''
      try {
        await apiService.put('/admin-env-profile', this.form)
        this.successMessage = 'Environment profile saved.'
      } catch (e) {
        this.errorMessage =
          (e.response && e.response.data && e.response.data.error) ||
          'Failed to save environment profile'
      } finally {
        this.saving = false
      }
    }
  }
})
</script>

<style scoped>
.env-textarea >>> textarea {
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  line-height: 1.4;
}
</style>
